import React, { useState, useEffect } from 'react';
import Styles from './styles.module.sass';
import { usePagoExpressResumen } from 'newHooks/usePagoExpress';
import MainLayout from 'newComponents/Layout/MainLayout';
import CreditoGuestLayout from 'newComponents/Layout/CreditoGuestLayout';
import { useValidateAccount } from 'newHooks/useValidateAccount';
import CardCreditoSears from 'newComponents/Cards/CardSears';

export default function InformacionTarjetaExpress() {
   const {
        numeroTarjeta,
        nombreTitular,
        montoMensualidad,
        montoMinimo,
        montoNuevoCorte,
        montoPagoNoGenerarIntereses,
        fechaLimite,
        handleContinuar
   } = usePagoExpressResumen()
   const { flow, account, dataCard, showView } = useValidateAccount()

    //- Codigo de instana para track de pagina 
    useEffect(()=>{
        // window.ineum('page', 'Express Info Credit-Page')
        // window.ineum('meta', 'portal', 'Credito')
    },[])

    return (
        <MainLayout>
            <CreditoGuestLayout flow={flow} >
                <div className={Styles?.boxInformacion}>
                    <CardCreditoSears 
                        numeroTarjeta={numeroTarjeta}
                        nombreTitular={nombreTitular}
                    />

                    <div className={Styles?.boxInfo}>
                        <div className={Styles?.titleResumen}>
                            <p>Resumen</p>
                        </div>
                        <ul className={Styles?.ulInfo}>
                            <li>
                                <div className={Styles?.boxInf}>
                                    <p className={Styles?.titulo}>Mensualidad total:</p>
                                    <p className={Styles?.valor}>{montoMensualidad}</p>
                                </div>
                            </li>
                            <li>
                                <div className={Styles?.boxInf}>
                                    <p className={Styles?.titulo}>Mínimo a pagar:</p>
                                    <p className={Styles?.valor}>{montoMinimo}</p>
                                </div>
                            </li>
                            <li>
                                <div className={Styles?.boxInf}>
                                    <p className={Styles?.titulo}>Saldo nuevo al corte:</p>
                                    <p className={Styles?.valor}>{montoNuevoCorte}</p>
                                </div>
                            </li>
                            <li>
                                <div className={Styles?.boxInf}>
                                    <p className={Styles?.titulo}>Pago para no generar intereses:</p>
                                    <p className={Styles?.valor}>{montoPagoNoGenerarIntereses}</p>
                                </div>
                            </li>
                            <li>
                                <div className={Styles?.boxInf}>
                                    <p className={Styles?.titulo}>Fecha Límite de pago:</p>
                                    <p className={Styles?.valor}>{fechaLimite}</p>
                                </div>
                            </li>
                        </ul>

                        <div className={Styles?.boxBtnContinuarPago}>
                            <button onClick={handleContinuar}>Continuar con el pago</button>
                        </div>
                    </div>
                </div>
            </CreditoGuestLayout>
        </MainLayout>
    )
}